import { SidebarInset } from '@goaltree/ui/components/sidebar'
import { Outlet, createFileRoute } from '@tanstack/react-router'
import { useConvexAuth } from 'convex/react'

import { AppSidebar } from '@/components/app-sidebar'
import { BottomNav } from '@/components/bottom-nav'
import { PersistentSidebarProvider as SidebarProvider } from '@/components/persistent-sidebar-provider'
import { useOnboardingMode } from '@/hooks/use-onboarding-mode'

export const Route = createFileRoute('/goals/new')({
  head: () => ({
    meta: [{ title: 'New goal — Goaltree' }, { name: 'robots', content: 'noindex, nofollow' }],
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const { isAuthenticated } = useConvexAuth()
  const showChrome = isAuthenticated && !useOnboardingMode().active

  return (
    <SidebarProvider>
      {showChrome && <AppSidebar />}
      <SidebarInset className="flex h-svh flex-col overflow-hidden bg-background">
        <Outlet />
      </SidebarInset>
      {showChrome && <BottomNav />}
    </SidebarProvider>
  )
}
